import { useMenuStore } from 'src/stores/menu';
import { RuntimeStoreContext } from 'src/types/runtime/piniaRuntimeContext';

import { QueryStore } from 'src/util/query/QueryStore';

const warmupUnfinishedElementCount = (_store: RuntimeStoreContext, queryStore: QueryStore) => {
	const menuStore = useMenuStore();

	void menuStore.fetchUnfinishedElementCountList({
		queryStore: queryStore,
	});

	void menuStore.fetchMainMenuItems({
		queryStore: queryStore,
	});
};

export { warmupUnfinishedElementCount };
